module.exports = __webpack_public_path__ + "img/4_004.d32c20a0.webp";